var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnselectedStar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.23077 13.8233L9 13.7033L8.76923 13.8233L4.41182 16.0903L5.24266 11.2965L5.28793 11.0353L5.09713 10.8513L1.58248 7.46094L6.44452 6.76178L6.70387 6.72449L6.8208 6.49002L9 2.12035L11.1792 6.49002L11.2961 6.72449L11.5555 6.76178L16.4175 7.46094L12.9029 10.8513L12.7121 11.0353L12.7573 11.2965L13.5882 16.0903L9.23077 13.8233Z",
    fill: "#1F222E",
    stroke: "#525C7A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnselectedStar);
export default __webpack_public_path__ + "static/media/unselected-star.9138618b9c08e5b7a29f0c1ce4364064.svg";
export { ForwardRef as ReactComponent };